// Converte qualquer formato comum de cor (#rgb, #rrggbb, rgb()/rgba()) em {r,g,b}
function parseColor(color) {
  if (!color) return null;

  const hexMatch = color
    .trim()
    .match(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i);
  if (hexMatch) {
    let hex = hexMatch[1];
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    }
    const num = parseInt(hex, 16);
    return {
      r: (num >> 16) & 255,
      g: (num >> 8) & 255,
      b: num & 255,
    };
  }

  const rgbMatch = color
    .trim()
    .match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
  if (rgbMatch) {
    return {
      r: Number(rgbMatch[1]),
      g: Number(rgbMatch[2]),
      b: Number(rgbMatch[3]),
    };
  }

  return null;
}

// Escurece uma cor em `amount` (0 a 1) e devolve em rgb()
export function darkenColor(color, amount = 0.30) {
  const rgb = parseColor(color);
  if (!rgb) return color;

  const darken = (channel) => Math.max(0, Math.round(channel * (1 - amount)));

  return `rgb(${darken(rgb.r)}, ${darken(rgb.g)}, ${darken(rgb.b)})`;
}

// Gradiente vertical: cor do evento no topo, um tom mais escuro dela embaixo
export function getBackgroundGradient(color, amount = 0.30) {
  if (!color) return undefined;

  return `linear-gradient(180deg, ${color} 0%, ${darkenColor(color, amount)} 100%)`;
}
